(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  class CartForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.updateButton = this.querySelector('[data-update]');

      this.querySelectorAll('[data-qty]').forEach((group) => {
        const input = group.querySelector('[data-qty-input]');
        const down = group.querySelector('[data-qty-down]');
        const up = group.querySelector('[data-qty-up]');

        down.addEventListener('click', () => this.step(input, -1));
        up.addEventListener('click', () => this.step(input, 1));
        input.addEventListener('change', () => this.submit());
      });
    }

    step(input, direction) {
      const next = Math.max(0, (parseInt(input.value, 10) || 0) + direction);
      input.value = next;
      this.submit();
    }

    submit() {
      if (this.form.requestSubmit && this.updateButton) {
        this.form.requestSubmit(this.updateButton);
      } else {
        this.form.submit();
      }
    }
  }

  if (!customElements.get('cart-form')) {
    customElements.define('cart-form', CartForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderNav extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('.header-nav__toggle');
      this.panel = this.querySelector('.header-nav__collapsible');
      if (!this.toggle) return;

      this.toggle.addEventListener('click', () => {
        this.setOpen(this.toggle.getAttribute('aria-expanded') !== 'true');
      });

      this.panel.addEventListener('click', (event) => {
        if (event.target.closest('a')) this.setOpen(false);
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.setOpen(false);
      });
    }

    setOpen(open) {
      this.toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      this.classList.toggle('is-open', open);
    }
  }

  if (!customElements.get('header-nav')) {
    customElements.define('header-nav', HeaderNav);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  class ProductForm extends HTMLElement {
    connectedCallback() {
      const dataEl = this.querySelector('[data-product-json]');
      this.variants = dataEl ? JSON.parse(dataEl.textContent).variants : [];
      this.form = this.querySelector('form');
      this.idInput = this.querySelector('[data-variant-id]');
      this.planInput = this.querySelector('[data-selling-plan]');
      this.priceEl = this.querySelector('[data-price]');
      this.addButton = this.querySelector('[data-add]');
      this.addText = this.querySelector('[data-add-text]');
      this.optionSelects = Array.from(this.querySelectorAll('[data-option-index]'));
      this.planRadios = Array.from(this.querySelectorAll('input[name="purchase_option"]'));

      this.optionSelects.forEach((select) =>
        select.addEventListener('change', () => this.update())
      );
      this.planRadios.forEach((radio) =>
        radio.addEventListener('change', () => this.update())
      );

      this.update();
    }

    get selectedPlan() {
      const checked = this.planRadios.find((r) => r.checked);
      return checked ? checked.dataset.plan : '';
    }

    currentVariant() {
      if (!this.optionSelects.length) return this.variants[0];
      const chosen = this.optionSelects
        .sort((a, b) => a.dataset.optionIndex - b.dataset.optionIndex)
        .map((s) => s.value);
      return this.variants.find(
        (v) => v.options.length === chosen.length && v.options.every((o, i) => o === chosen[i])
      );
    }

    update() {
      const variant = this.currentVariant();
      const plan = this.selectedPlan;

      if (this.planInput) this.planInput.value = plan;

      if (!variant) {
        this.setUnavailable(window.themeStrings ? window.themeStrings.unavailable : 'Unavailable');
        return;
      }

      if (this.idInput) this.idInput.value = variant.id;

      let price = variant.price;
      if (plan && variant.plans && variant.plans[plan]) {
        price = variant.plans[plan];
      }
      if (this.priceEl) this.priceEl.textContent = price;

      const stickyPrice = document.querySelector('[data-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = price;

      if (this.addButton) this.addButton.disabled = !variant.available;
      if (this.addText) {
        this.addText.textContent = variant.available
          ? this.addButton.dataset.addLabel
          : this.addButton.dataset.soldOut;
      }
    }

    setUnavailable(text) {
      if (this.addButton) this.addButton.disabled = true;
      if (this.addText) this.addText.textContent = text;
    }
  }

  if (!customElements.get('product-form')) {
    customElements.define('product-form', ProductForm);
  }

  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.mainImage = this.querySelector('.product__media-main img');
      this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
      this.thumbs.forEach((thumb) =>
        thumb.addEventListener('click', () => {
          if (this.mainImage) {
            this.mainImage.src = thumb.dataset.full;
            this.mainImage.removeAttribute('srcset');
            const thumbImg = thumb.querySelector('img');
            if (thumbImg) this.mainImage.alt = thumbImg.alt;
          }
          this.thumbs.forEach((t) => t.classList.remove('is-active'));
          thumb.classList.add('is-active');
        })
      );
    }
  }

  if (!customElements.get('product-gallery')) {
    customElements.define('product-gallery', ProductGallery);
  }

  document.addEventListener('click', (event) => {
    const stickyAdd = event.target.closest('[data-sticky-add]');
    if (!stickyAdd) return;
    const form = document.getElementById('product-form');
    if (form) form.requestSubmit();
  });

  } catch(e) { console.error(e); }
})();
})();
